import { render, staticRenderFns } from "./ColumnsAdsManagerMain.vue?vue&type=template&id=d66e7466&scoped=true&"
import script from "./ColumnsAdsManagerMain.vue?vue&type=script&lang=ts&"
export * from "./ColumnsAdsManagerMain.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnsAdsManagerMain.vue?vue&type=style&index=0&id=d66e7466&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66e7466",
  null
  
)

export default component.exports